import { $, $$ } from "@utils/dom";
import ProductPreview from "@modules/product-preview";

const DEFAULT_SECTION_ID = `product-recommendations-default-template`;
const VARIANTS_SECTION_ID = `product-recommendations-variants-template`;

const DEFAULT_LIMIT = `3`;
const INTENT = `related`;

class ProductRecommendations {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.targetContainer = $('.product-recommendations__wrap', this.el);

    if (this.el.dataset.variantsPicker) {
      this.sectionId = VARIANTS_SECTION_ID
    } else {
      this.sectionId = DEFAULT_SECTION_ID;
    }

    if (this.el.dataset.limit) {
      this.limit = this.el.dataset.limit;
    } else {
      this.limit = DEFAULT_LIMIT;
    }

    // get product ID from data attribute and build fetch URL
    this.productId = this.el.dataset?.productId;
    if(this.productId) this.fetchURL = `${window?.Shopify.routes.root}recommendations/products?product_id=${this.productId}&limit=${this.limit}&section_id=${this.sectionId}&intent=${INTENT}`;

    this._onFetched = this._onFetched.bind(this);
  }


  destroy() {
    if(this.productPreviewInstances) {
      this.productPreviewInstances.forEach(instance => instance.destroy())
      this.productPreviewInstances = null;
    }

    this.el = null;
    this.emitter = null;
    this.targetContainer = null;
    this.productId = null;
    this.fetchURL = null;
    this._onFetched = null;
  }

  start() {
    this._getRecommendations();
  }

  _getRecommendations() {
    if(this.fetchURL === undefined) return;
    fetch(this.fetchURL)
      .then(response => response.text())
      .then(this._onFetched)
  }

  _onFetched(text) {
    // insert fetched content in target container
    this.targetContainer.innerHTML = text;

    this.productPreviewElements = $$('.product-preview.--with-variants-picker', this.targetContainer);

    // init all product preview instances
    if(this.productPreviewElements) {
      this.productPreviewInstances = [...this.productPreviewElements].map(el => new ProductPreview(el, this.emitter));
      this.productPreviewInstances.forEach(instance => instance.init());
    }

    // update scroll
    this.emitter.emit('SiteScroll.update');
  }

}

export default ProductRecommendations;
